/** Money arrives from the API as a `numeric` string; never parse it into a float
 *  for display maths — format it directly. */
export function money(value: string | null | undefined, currency = "USD", locale = "en"): string {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return value;
  return new Intl.NumberFormat(locale, { style: "currency", currency }).format(n);
}

export function integer(value: number | null | undefined, locale = "en"): string {
  if (value === null || value === undefined) return "—";
  return new Intl.NumberFormat(locale).format(value);
}

export function whenever(iso: string | null | undefined, locale = "en"): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleString(locale, { dateStyle: "medium", timeStyle: "short" });
}

/**
 * For a calendar date with no meaningful time-of-day — an invoice's issue/due
 * date, say — rather than a real timestamped event. Those are stored as UTC
 * midnight (`z.coerce.date()` on a bare `YYYY-MM-DD`), so formatting them in
 * the viewer's local timezone (what `whenever` does, correctly, for actual
 * events) can walk the displayed date back a day west of UTC. Pinning to UTC
 * is what makes the date the server was given the date the viewer sees.
 */
export function dateOnly(iso: string | null | undefined, locale = "en"): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString(locale, { dateStyle: "medium", timeZone: "UTC" });
}

const BYTE_UNITS = ["B", "KB", "MB", "GB"] as const;

export function fileSize(bytes: number | null | undefined, locale = "en"): string {
  if (bytes === null || bytes === undefined) return "—";
  let value = bytes;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < BYTE_UNITS.length - 1) {
    value /= 1024;
    unitIndex++;
  }
  const formatted = new Intl.NumberFormat(locale, {
    maximumFractionDigits: unitIndex === 0 ? 0 : 1,
  }).format(value);
  return `${formatted} ${BYTE_UNITS[unitIndex]}`;
}
